// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"2c4dd9c8","64":"c447b719","312":"0ae640b6","692":"8e67f1e2"}[chunkId] + ".chunk.js";
};